import React from 'react';
import { 
    List, 
    Datagrid,
    TextField, 
    DateField,
    Show,
    SimpleShowLayout,
    ListButton,
    CardActions,
    EditButton
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from './LinkToCreate'
import ErrorBoundary from '../ErrorBoundary';
import jwt_decode from 'jwt-decode'

let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
});

const UpdateButton=({record}) =>{

    return (record && (record.qa_init === null || record.qa_init === '') && record.qa_date === null && record.branch_code === branch_code) ?  <EditButton record={record} label="Update" />  : '';
};


const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};

const ShowDetails = ({record}) => {
    const classes = useStyles();
    return(
        <div className={classes.root}>
            <center>
            <table style={{textAlign: 'left', width:'90%', padding: '5'}}>
                <tbody>
                    <tr>
                        <th>Unit Contorl Number:</th><td >{record && record.ucn? record.ucn:'' }</td>
                        <th>SSN:</th><td >{record && record.ssn? record.ssn:'' }</td>
                    </tr>
                    <tr>
                        <th>Tech initial:</th><td>{record && record.tech_init? record.tech_init: ''}</td>
                        <th>Tech Date:</th><td>{record && record.tech_date? moment(record.tech_date).format('MM/DD/YYYY') : ''}</td>
                    </tr>
                    <tr>
                        <th>Comments:</th><td colSpan={3}>{record && record.comments? record.comments:'' }</td>
                    </tr>
                    <tr>
                        <th>PS/CMD initial:</th><td>{record && record.ps_init? record.ps_init: ''}</td>
                        <th>PS/CMD Date:</th><td>{record && record.ps_date? moment(record.ps_date).format('MM/DD/YYYY') : ''}</td>
                    </tr>
                    <tr>
                        <th>Nextdue date:</th><td colSpan={3}>{record && record.next_date? moment(record.next_date).format('MM/DD/YYYY') : ''}</td>
                    </tr>
                    <tr>
                        <th>QA initial:</th><td>{record && record.qa_init? record.qa_init: ''}</td>
                        <th>QA Date:</th><td>{record && record.qa_date? moment(record.qa_date).format('MM/DD/YYYY') : ''}</td>
                    </tr>
                    <tr>
                        <th>Deferral Code:</th><td colSpan={3}>{record && record.deferral_code?record.deferral_code : ''}</td>
                    </tr>
                    <tr>
                        <th>Deferral Date:</th><td>{record && record.deferral_date? moment(record.deferral_date).format('MM/DD/YYYY') : ''}</td>
                        <th>Deferral expire Date:</th><td>{record && record.deferral_exp_date? moment(record.deferral_exp_date).format('MM/DD/YYYY') : ''}</td>
                    </tr>
                    <tr>
                        <th>Deferral Comments:</th><td colSpan={3}>{record && record.deferral_comments?record.deferral_comments : ''}</td>
                    </tr>
                </tbody>
            </table>
            </center>
        </div>
    )
}

const SpeShow = (props ) =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    
    >
        <SimpleShowLayout >
        <ShowDetails />     
        </SimpleShowLayout>
    </Show>
);

const SpeActions = ({...props}) => (
    console.log(props),
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/donors'} label="Donors List" />
    </CardActions>
);


export const SpeList = ({ classes, permissions, ...props }) => (
    <ErrorBoundary>
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<SpeActions/>} 
        title="SPE Tracking"
        >
        
        <Datagrid  classes={{ headerCell: classes.header }}  expand={<SpeShow />} >      
            <TextField source="ucn"     label="UCN" />
            <DateField source="tech_date"    label="Tech date" locales="en-us"/>
            <TextField source="ps_action"     label="PS/CMD Action" />
            <DateField source="next_date"    label="Next due date" locales="en-us"/>
            {((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 3 ||
             (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'PHYN' ) &&  <UpdateButton  />}
        </Datagrid>
    </List>
    </ErrorBoundary>

);


export default withStyles(listStyles)(SpeList)